// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Characters_FullsizeText__jwSX7 {
  color: rgb(36, 184, 184);
  font-style: italic;
  font-size: .70rem;
}

.Characters_WhiteBack__-qYo8 {
  background-color: #fff;
  border: 1px solid #39606e;
  min-height: 75px;
}

.Characters_BreakWhite__ansHd {
  border-top: 1px solid #fff;
}

.Characters_Top__iQapW {
  background-color: #146871;
  background-color: #39606e;
  background-color: #1a8692;
  background-color: #0095a3;
  color: #fff;
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Characters_TopText__6Qy2- {
  color: #fff;
}

.Characters_Top__iQapW:hover {
  background-color: #052b39;
  transform: scale(1.05); 
}

.Characters_Top2__lQS0U {
  background-color: #39606e;
  color: #fff;
}

.Characters_Small__3Ni2P {
    font-size: .75rem ;
  }

.Characters_BreakTitle__8s1w\\+ {
  border-top: 10px solid #e8f0f1;
}

.Characters_FullsizeText__jwSX7:hover {
  color: rgb(14, 66, 66);
  cursor: pointer;
}

.Characters_FeatureBox1__xJ895 {
    background-color: #c1f1f7;
    background-color: #911f83;
    padding: 20px;
}

.Characters_FeatureBoxM__H-buw {
    background-color: #c1f1f7;
    background-color: #911f83;
    padding: 8px 10px 2px 10px;
}

.Characters_ImagesIndex__ZgJ2N {
    object-fit: contain;
    height: 300px;
    width: 100%; 
}

.Characters_TopCard__K6glf {
    border: 1px solid #fff;
    background-color: #fff;
 }

 .Characters_TopCard2__aYPTz {
    min-height: 40px;
    color: rgb(140, 111, 25, 99%);
    overflow: hidden;
}

  .Characters_FullsizeText__jwSX7 {
    color: rgb(36, 184, 184);
    font-style: italic;
  }
  
  .Characters_FullsizeText__jwSX7:hover {
    cursor: pointer;
  }

.Characters_Break1__eVP9h {
    border-top: 1px solid #d0d9db;
}

.Characters_BreakCos1__ysRfW {
  border-top: 1px solid #fff;
}

.Characters_ImagesLand__lbdUe {
  object-fit: contain;
  height: 300px;
  width: 100%;
}

.Characters_ImageBox__q2VD4 {
  border: 2px solid #fff;
}

.Characters_ImageBox2__JmD5M {
  border: 1px solid #d0d9db;
  background-color: #fff;
}

.Characters_Para__a5NGL {
  min-height: 25px;
}

.Characters_BorderRight__NqSmf {
  border-right: 1px solid #a7e9f2;
}

.Characters_Role__MV-mM {
  color: #494d70;
}

.Characters_Info__LJ4nk {
  color: #000;
}

.Characters_Top__iQapW i {
  color: #fff;
}

.Characters_Top__iQapW:hover i {
  color: #fff;
}

.Characters_ImagesLand__lbdUe {
  object-fit: cover;
  height: 300px;
  width: 100%;
}

.Characters_Images__GwkyH {
  object-fit: contain;
  height: 500px;
  width: 100%;
}

.Characters_Header__hjIKn {
  background-color: #fff;
}

.Characters_Header__hjIKn i {
  color: #666;
}

.Characters_Bold__2RCjC { 
  font-weight: 700;
}

.Characters_BoldScene__naxZX {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 700;
}

.Characters_ButtonLine__dAoSC {
  background-color: #fff;
  border-top: 3px solid #fff;
}

.Characters_BoldTitle__tgeAU {
  font-weight: 700;
  background-color: #d6fcff;
}

.Characters_BoldTitleCall__s93Fv {
  font-weight: 700;
  color: #fff;
  background-color: #000;
}

/* .Button {
  color: rgb(41, 180, 180);
  cursor: pointer;
} */

/* .Button {
  color: #013441;
  font-weight: 700;
  cursor: pointer;
}

.Button:hover {
  color: #04809f;
  font-weight: 700;
} */

.Characters_Button__QG-vd {
  color: #036d87;
  /* font-weight: 700; */
  cursor: pointer;
}

.Characters_Button__QG-vd:hover {
  color: #04809f;
  font-weight: 700;
}

.Characters_Title__Ro5DP {
  background-color: #fff;
}

.Characters_SubTitle__ShLGi {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Characters_InputBar__LEwxS {
  background: #ffffff;
  border: 1px solid #e0e3eb;
  box-sizing: border-box;
  height: 30px !important;
  border-radius: 20px;
  color: #242a3d;
  padding-left: 40px;
  margin-bottom: 16px;
} 

@media screen and (max-width: 780px) {
  .Characters_ImageBox__q2VD4 {
    border: 2px solid #d0d9db;
  }

  .Characters_ImageBox2__JmD5M {
    border: 2px solid #fff;
  }
}

@media screen and (max-width: 600px) {
  .Characters_Icon__99Jsi i {
    font-size: 1rem;
  }

  .Characters_InputBar__LEwxS {
    height: 20px !important;
    font-size: .75rem !important;
  }

  .Characters_Titlelist__dIHLL {
    font-size: 1rem ;
  }

  .Characters_BoldTitleCall__s93Fv {
    font-weight: 700;
    color: #fff;
    background-color: #000;
    font-size: .75rem ;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Characters.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EAGzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;IACI,kBAAkB;EACpB;;AAEF;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;CACzB;;CAEA;IACG,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;EAEE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;AAEF;IACI,6BAA6B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;;;;;;;;;GASG;;AAEH;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".FullsizeText {\n  color: rgb(36, 184, 184);\n  font-style: italic;\n  font-size: .70rem;\n}\n\n.WhiteBack {\n  background-color: #fff;\n  border: 1px solid #39606e;\n  min-height: 75px;\n}\n\n.BreakWhite {\n  border-top: 1px solid #fff;\n}\n\n.Top {\n  background-color: #146871;\n  background-color: #39606e;\n  background-color: #1a8692;\n  background-color: #0095a3;\n  color: #fff;\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.TopText {\n  color: #fff;\n}\n\n.Top:hover {\n  background-color: #052b39;\n  -webkit-transform: scale(1.05);\n  -ms-transform: scale(1.05);\n  transform: scale(1.05); \n}\n\n.Top2 {\n  background-color: #39606e;\n  color: #fff;\n}\n\n.Small {\n    font-size: .75rem ;\n  }\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.FullsizeText:hover {\n  color: rgb(14, 66, 66);\n  cursor: pointer;\n}\n\n.FeatureBox1 {\n    background-color: #c1f1f7;\n    background-color: #911f83;\n    padding: 20px;\n}\n\n.FeatureBoxM {\n    background-color: #c1f1f7;\n    background-color: #911f83;\n    padding: 8px 10px 2px 10px;\n}\n\n.ImagesIndex {\n    object-fit: contain;\n    height: 300px;\n    width: 100%; \n}\n\n.TopCard {\n    border: 1px solid #fff;\n    background-color: #fff;\n }\n\n .TopCard2 {\n    min-height: 40px;\n    color: rgb(140, 111, 25, 99%);\n    overflow: hidden;\n}\n\n  .FullsizeText {\n    color: rgb(36, 184, 184);\n    font-style: italic;\n  }\n  \n  .FullsizeText:hover {\n    cursor: pointer;\n  }\n\n.Break1 {\n    border-top: 1px solid #d0d9db;\n}\n\n.BreakCos1 {\n  border-top: 1px solid #fff;\n}\n\n.ImagesLand {\n  object-fit: contain;\n  height: 300px;\n  width: 100%;\n}\n\n.ImageBox {\n  border: 2px solid #fff;\n}\n\n.ImageBox2 {\n  border: 1px solid #d0d9db;\n  background-color: #fff;\n}\n\n.Para {\n  min-height: 25px;\n}\n\n.BorderRight {\n  border-right: 1px solid #a7e9f2;\n}\n\n.Role {\n  color: #494d70;\n}\n\n.Info {\n  color: #000;\n}\n\n.Top i {\n  color: #fff;\n}\n\n.Top:hover i {\n  color: #fff;\n}\n\n.ImagesLand {\n  object-fit: cover;\n  height: 300px;\n  width: 100%;\n}\n\n.Images {\n  object-fit: contain;\n  height: 500px;\n  width: 100%;\n}\n\n.Header {\n  background-color: #fff;\n}\n\n.Header i {\n  color: #666;\n}\n\n.Bold { \n  font-weight: 700;\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 700;\n}\n\n.ButtonLine {\n  background-color: #fff;\n  border-top: 3px solid #fff;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.BoldTitleCall {\n  font-weight: 700;\n  color: #fff;\n  background-color: #000;\n}\n\n/* .Button {\n  color: rgb(41, 180, 180);\n  cursor: pointer;\n} */\n\n/* .Button {\n  color: #013441;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.Button:hover {\n  color: #04809f;\n  font-weight: 700;\n} */\n\n.Button {\n  color: #036d87;\n  /* font-weight: 700; */\n  cursor: pointer;\n}\n\n.Button:hover {\n  color: #04809f;\n  font-weight: 700;\n}\n\n.Title {\n  background-color: #fff;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.InputBar {\n  background: #ffffff;\n  border: 1px solid #e0e3eb;\n  box-sizing: border-box;\n  height: 30px !important;\n  border-radius: 20px;\n  color: #242a3d;\n  padding-left: 40px;\n  margin-bottom: 16px;\n} \n\n@media screen and (max-width: 780px) {\n  .ImageBox {\n    border: 2px solid #d0d9db;\n  }\n\n  .ImageBox2 {\n    border: 2px solid #fff;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .Icon i {\n    font-size: 1rem;\n  }\n\n  .InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n  }\n\n  .Titlelist {\n    font-size: 1rem ;\n  }\n\n  .BoldTitleCall {\n    font-weight: 700;\n    color: #fff;\n    background-color: #000;\n    font-size: .75rem ;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FullsizeText": `Characters_FullsizeText__jwSX7`,
	"WhiteBack": `Characters_WhiteBack__-qYo8`,
	"BreakWhite": `Characters_BreakWhite__ansHd`,
	"Top": `Characters_Top__iQapW`,
	"TopText": `Characters_TopText__6Qy2-`,
	"Top2": `Characters_Top2__lQS0U`,
	"Small": `Characters_Small__3Ni2P`,
	"BreakTitle": `Characters_BreakTitle__8s1w+`,
	"FeatureBox1": `Characters_FeatureBox1__xJ895`,
	"FeatureBoxM": `Characters_FeatureBoxM__H-buw`,
	"ImagesIndex": `Characters_ImagesIndex__ZgJ2N`,
	"TopCard": `Characters_TopCard__K6glf`,
	"TopCard2": `Characters_TopCard2__aYPTz`,
	"Break1": `Characters_Break1__eVP9h`,
	"BreakCos1": `Characters_BreakCos1__ysRfW`,
	"ImagesLand": `Characters_ImagesLand__lbdUe`,
	"ImageBox": `Characters_ImageBox__q2VD4`,
	"ImageBox2": `Characters_ImageBox2__JmD5M`,
	"Para": `Characters_Para__a5NGL`,
	"BorderRight": `Characters_BorderRight__NqSmf`,
	"Role": `Characters_Role__MV-mM`,
	"Info": `Characters_Info__LJ4nk`,
	"Images": `Characters_Images__GwkyH`,
	"Header": `Characters_Header__hjIKn`,
	"Bold": `Characters_Bold__2RCjC`,
	"BoldScene": `Characters_BoldScene__naxZX`,
	"ButtonLine": `Characters_ButtonLine__dAoSC`,
	"BoldTitle": `Characters_BoldTitle__tgeAU`,
	"BoldTitleCall": `Characters_BoldTitleCall__s93Fv`,
	"Button": `Characters_Button__QG-vd`,
	"Title": `Characters_Title__Ro5DP`,
	"SubTitle": `Characters_SubTitle__ShLGi`,
	"InputBar": `Characters_InputBar__LEwxS`,
	"Icon": `Characters_Icon__99Jsi`,
	"Titlelist": `Characters_Titlelist__dIHLL`
};
export default ___CSS_LOADER_EXPORT___;
